module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_sapporo@2x-269c6c5edafd1075edfa4c1948febf40.webp";